
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6F7078","d":"M13.167 14.667a.833.833 0 10-1.667 0v2.5a.833.833 0 001.667 0v-2.5z"}}),_c('path',{attrs:{"fill":"#6F7078","d":"M7.333 8v2.5H5.667c-.92 0-1.667.746-1.667 1.667v7.5c0 .92.746 1.666 1.667 1.666H19c.92 0 1.667-.746 1.667-1.666v-7.5c0-.92-.747-1.667-1.667-1.667h-1.667V8a5 5 0 00-10 0zm5-3.333A3.333 3.333 0 009 8v2.5h6.667V8a3.333 3.333 0 00-3.334-3.333zm-6.666 7.5H19v7.5H5.667v-7.5z","clip-rule":"evenodd","fill-rule":"evenodd"}}),_c('path',{attrs:{"fill":"none","d":"M13.167 14.667a.833.833 0 10-1.667 0v2.5a.833.833 0 001.667 0v-2.5z"}}),_c('path',{attrs:{"fill":"#707070","d":"M7.333 8v2.5H5.667c-.92 0-1.667.746-1.667 1.667v7.5c0 .92.746 1.666 1.667 1.666H19c.92 0 1.667-.746 1.667-1.666v-7.5c0-.92-.747-1.667-1.667-1.667h-1.667V8a5 5 0 00-10 0zm5-3.333A3.333 3.333 0 009 8v2.5h6.667V8a3.333 3.333 0 00-3.334-3.333zm-6.666 7.5H19v7.5H5.667v-7.5z","clip-rule":"evenodd","fill-rule":"evenodd"}})])
          )
        }
      }
    